import { actSaga } from './act'
import { actUnpaidSaga } from './actUnpaid'
import { actStatusesSaga } from './actStatuses'

export const actsSagas = [actSaga(), actUnpaidSaga(), actStatusesSaga()]
